import { Api } from 'utils';

class GeneralService {
  static getSelects = async (params?: any) =>
    Api.createResponse('app/generals/get-selects', params);
  static savePayment = async (params?: any) =>
    Api.createResponse('app/generals/save-payment', params);
  static getCities = async (params?: any) =>
    Api.createResponse('app/generals/get-cities', params);
}

export default GeneralService;
